export type Color =
  | "blue"
  | "light-blue"
  | "green"
  | "yellow"
  | "salmon"
  | "brown"
  | "orange";

export function getBg(color: Color) {
  switch (color) {
    case "blue":
      return "bg-blue";
    case "light-blue":
      return "bg-light-blue";
    case "green":
      return "bg-green";
    case "yellow":
      return "bg-yellow";
    case "salmon":
      return "bg-salmon";
    case "brown":
      return "bg-brown";
    case "orange":
      return "bg-orange";
    default:
      return "";
  }
}

export function getOutline(color: Color) {
  switch (color) {
    case "blue":
      return "outline-blue/50";
    case "light-blue":
      return "outline-light-blue/50";
    case "green":
      return "outline-green/50";
    case "yellow":
      return "outline-yellow/50";
    case "salmon":
      return "outline-salmon/50";
    case "brown":
      return "outline-brown/50";
    case "orange":
      return "outline-orange/50";
    default:
      return "";
  }
}

export function getButton(color: Color) {
  switch (color) {
    case "blue":
      return "button-blue";
    case "light-blue":
      return "button-light-blue";
    case "green":
      return "button-green";
    case "salmon":
      return "button-salmon";
    case "orange":
      return "button-orange";
    default:
      return "button";
  }
}
